export default __webpack_public_path__ + "static/media/Menu.480df439.svg";